import React from "react";
import Hero from "@/components/Hero";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import {
  Intro, WhyRevive, Treatments, Peptides, NAD, Emerging,
  Conditions, ReviveMethod, Financing, International,
} from "@/components/HomeSections";

const Home = () => (
  <div className="bg-offwhite pb-16 md:pb-0">
    <Navbar />
    <main>
      <Hero />
      <Intro />
      <WhyRevive />
      <Treatments />
      <Peptides />
      <NAD />
      <Emerging />
      <Conditions />
      <ReviveMethod />
      <Financing />
      <International />
    </main>
    <Footer />
    <FloatingCTAs />
  </div>
);

export default Home;
